import {isNotNil} from 'ramda';

import {SaveSaleVehicleFinancingBody, VehicleFinancingType} from '@dms/api/vehicle';
import {RATE_MATRIX_BALLOON_BRACKETS} from '@dms/features/vehicle-financing-template';

import {Nullish} from 'shared/web';

const ascending = (left: number, right: number) => left - right;

/**
 * The balloon brackets the panel offers: the standard brackets, plus every bracket the body already
 * holds a cell for, so a variant configured off-bracket stays reachable. Standard financing has no
 * balloon dimension and therefore no brackets.
 */
export function getBalloonBrackets(
  body: SaveSaleVehicleFinancingBody | Nullish,
  type: VehicleFinancingType
) {
  if (type !== 'BALLOON') {
    return [];
  }

  const configuredBrackets = (body?.rateMatrix.cells ?? [])
    .map((cell) => cell.balloonPayment)
    .filter((bracket): bracket is number => isNotNil(bracket));

  return Array.from(new Set([...RATE_MATRIX_BALLOON_BRACKETS, ...configuredBrackets])).sort(
    ascending
  );
}
